import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { PmiButton } from 'shell/components/shared/button';
import TypeEventList from '../type-event-list';
import { FiltersFormPublishedEvents } from 'system/pages/search-published-events/list/types';
import PmiTextField from 'shell/components/shared/text-field';
import { DateTimePicker } from '@mui/lab';

interface FiltersPublishedEventsProps {
  filterPublishedEventsForm: FormikProps<FiltersFormPublishedEvents>;
}

const FiltersPublishedEvents = ({
  filterPublishedEventsForm,
}: FiltersPublishedEventsProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-published-events-content"
        id="panel-published-events-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterPublishedEventsForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={8}>
              <TypeEventList
                value={filterPublishedEventsForm.values.typeEventCode || ''}
                onChange={(e) =>
                  filterPublishedEventsForm.setFieldValue('typeEventCode', e.target.value)
                }
                onBlur={() => filterPublishedEventsForm.setFieldTouched('typeEventCode', true)}
                error={
                  filterPublishedEventsForm.touched.typeEventCode &&
                  Boolean(filterPublishedEventsForm.errors.typeEventCode)
                }
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <DateTimePicker
                label="Data e ora pubblicazione da"
                aria-label="Data e ora pubblicazione da"
                value={filterPublishedEventsForm.values.dateTimePublicationFrom || null}
                onChange={(date) =>
                  filterPublishedEventsForm.setFieldValue('dateTimePublicationFrom', date)
                }
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="dateTimePublicationFrom"
                    error={
                      filterPublishedEventsForm.touched.dateTimePublicationFrom &&
                      Boolean(filterPublishedEventsForm.errors.dateTimePublicationFrom)
                    }
                    helperText={filterPublishedEventsForm.errors.dateTimePublicationFrom}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <DateTimePicker
                label="Data e ora pubblicazione a"
                aria-label="Data e ora pubblicazione a"
                value={filterPublishedEventsForm.values.dateTimePublicationTo || null}
                onChange={(date) =>
                  filterPublishedEventsForm.setFieldValue('dateTimePublicationTo', date)
                }
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="dateTimePublicationTo"
                    error={
                      filterPublishedEventsForm.touched.dateTimePublicationTo &&
                      Boolean(filterPublishedEventsForm.errors.dateTimePublicationTo)
                    }
                    helperText={filterPublishedEventsForm.errors.dateTimePublicationTo}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterPublishedEventsForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersPublishedEvents.displayName = 'Filters Published Events component';

export default FiltersPublishedEvents;
